















import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ButtonBack extends Vue {
  get hasPrepend(): boolean {
    return !!this.$slots.prepend;
  }
}
